(function() {
  'use strict';

  function initRequestQuoteModals() {
    document.querySelectorAll('[data-rq-open]').forEach(function(openBtn) {
      var sid = openBtn.getAttribute('data-rq-open');
      var overlayId = 'ds-request-quote-overlay-' + sid;
      if (!document.getElementById(overlayId)) {
        var tpl = document.getElementById('ds-rq-tpl-' + sid);
        if (tpl) {
          var clone = document.importNode(tpl.content, true);
          document.body.appendChild(clone);
        }
      }
      var overlay = document.getElementById(overlayId);
      var closeBtn = document.getElementById('ds-request-quote-close-' + sid);
      function openModal() { if (overlay) { overlay.classList.add('ds-advisory--open'); document.body.style.overflow = 'hidden'; } }
      function closeModal() { if (overlay) { overlay.classList.remove('ds-advisory--open'); document.body.style.overflow = ''; } }
      openBtn.addEventListener('click', openModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (overlay) overlay.addEventListener('click', function(e) { if (e.target === overlay) closeModal(); });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.ds-advisory-overlay.ds-advisory--open').forEach(function(ov) {
          ov.classList.remove('ds-advisory--open');
          document.body.style.overflow = '';
        });
      }
    });

    document.querySelectorAll('[id^="ds-rq-submit-"]').forEach(function(submitBtn) {
      if (submitBtn._rqInitialized) return;
      submitBtn._rqInitialized = true;
      submitBtn.addEventListener('click', function() {
        var sid = submitBtn.id.replace('ds-rq-submit-', '');
        var nameEl = document.getElementById('ds-rq-name-' + sid);
        var emailEl = document.getElementById('ds-rq-email-' + sid);
        var msgEl = document.getElementById('ds-rq-msg-' + sid);
        var name = (nameEl ? nameEl.value : '').trim();
        var email = (emailEl ? emailEl.value : '').trim();
        var msg = (msgEl ? msgEl.value : '').trim();
        if (!name || !email || !msg) { alert('Please fill in all fields.'); return; }

        var pageForm = document.getElementById('contact_form');
        if (!pageForm) { alert('Form not available. Please refresh and try again.'); return; }

        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending...';

        function setField(n, v) {
          var el = pageForm.querySelector('[name="' + n + '"]');
          if (el) el.value = v;
        }

        setField('contact[name]', name);
        setField('contact[email]', email);

        var productTitle = (document.querySelector('h1.product__title, .cs-pr-title, .product-title, [data-product-title]') || {textContent: ''}).textContent.trim() || document.title.split('|')[0].trim();
        setField('contact[message]', '[Quote Request - Customization]\nProduct: ' + productTitle + '\nFrom: ' + name + '\nEmail: ' + email + '\n\n' + msg);

        var retInput = pageForm.querySelector('[name="return_to"]');
        if (!retInput) {
          retInput = document.createElement('input');
          retInput.type = 'hidden';
          retInput.name = 'return_to';
          pageForm.appendChild(retInput);
        }
        retInput.value = window.location.pathname + '?quote_request_sent=1';

        // Use same flag as ds-quote-modal.js to avoid double-protecting the form
        if (!pageForm._captchaProtected) {
          if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
            window.Shopify.captcha.protect(pageForm);
          }
          pageForm._captchaProtected = true;
        }

        // Reset button after 8s if page doesn't navigate (e.g. captcha fail or validation error)
        setTimeout(function() {
          if (submitBtn.disabled) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send request';
          }
        }, 8000);

        var nativeSubmitBtn = pageForm.querySelector('button[type="submit"], input[type="submit"]');
        if (nativeSubmitBtn) {
          nativeSubmitBtn.click();
        } else {
          pageForm.submit();
        }
      });
    });
  }

  // Show success toast if returning from form submit
  if (window.location.search.indexOf('quote_request_sent=1') !== -1) {
    var toast = document.createElement('div');
    toast.style.cssText = 'position:fixed;bottom:32px;left:50%;transform:translateX(-50%);background:#000;color:#fff;padding:14px 28px;font-size:13px;letter-spacing:0.08em;z-index:99999;opacity:0;transition:opacity 0.3s;pointer-events:none;white-space:nowrap;';
    toast.textContent = "Thank you! We'll be in touch shortly.";
    document.body.appendChild(toast);
    requestAnimationFrame(function() { requestAnimationFrame(function() { toast.style.opacity = '1'; }); });
    setTimeout(function() {
      toast.style.opacity = '0';
      setTimeout(function() { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 400);
    }, 5000);
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRequestQuoteModals);
  } else {
    initRequestQuoteModals();
  }
})();